import { Box, Stack } from "@mui/material"
import { Button, Chip, Icon, Typography } from "@cakemail-org/ui-components-v2"
import { TLandingPageHead } from "./types"
import "./styles.scss"
import { useTranslation } from "react-i18next"

export function LandingPageHead({ cta, ctaTxt, features, imgSrc, support, title, addOn }: TLandingPageHead) {
    const { t, i18n } = useTranslation()

    return <Stack className="landingPageHead" direction={{ mobile: 'column', xs: 'row' }} gap={16} justifyContent="space-between">
        <Stack >
            <Stack className="support" direction="row" alignItems="center" gap={4}>
                {addOn && <Chip label={t("general-add-on")} color="cloud" lowerCased squared icon={<Icon name="LinkArrow18" />} />}
                <Typography variant="body1L" className="semiBold uppercase">{support}</Typography>
            </Stack>
            <Typography variant="h1L" className="title">{title}</Typography>
            {features && <Stack className="features">
                {features.map((t, index) => {
                    return <Stack key={`feature-${index}`} direction="row" alignItems="center"><Icon name="Checkmark14" color="secondary" /> <Typography variant="body1L">{t}</Typography></Stack>
                })}
            </Stack>}
            {ctaTxt &&
                <Button onClick={cta} color="secondary" name="emailAPIHeroCTA" > {ctaTxt}</Button>
            }
        </Stack>
        <Box >
            <img src={imgSrc} />
        </Box>
    </Stack>
}